import type { ReactNode } from "react";
import { CheckCircle2, CircleDashed, Loader2, XCircle } from "lucide-react";
import type { StepState } from "@/lib/dataTransfer";

const STATE_TEXT: Record<StepState, string> = {
  pending: "a fazer",
  running: "em andamento",
  done: "concluído",
  failed: "falhou",
};

/** O marcador de um passo: o número enquanto ele espera, e o estado depois. */
export function StepMarker({ state, number }: { state: StepState; number?: number }) {
  const icon =
    state === "running" ? (
      <Loader2 className="size-5 shrink-0 animate-spin text-primary" />
    ) : state === "done" ? (
      <CheckCircle2 className="size-5 shrink-0 text-state-ok" />
    ) : state === "failed" ? (
      <XCircle className="size-5 shrink-0 text-state-error" />
    ) : number != null ? (
      <span className="flex size-5 shrink-0 items-center justify-center rounded-full border border-border text-caption font-semibold text-muted-foreground">
        {number}
      </span>
    ) : (
      <CircleDashed className="size-5 shrink-0 text-muted-foreground" />
    );
  return (
    <>
      {icon}
      <span className="sr-only">({STATE_TEXT[state]})</span>
    </>
  );
}

/** Um dos dois passos de cada lado da página Dados, com o conteúdo dele. */
export function Step({
  number,
  title,
  state,
  children,
}: {
  number: number;
  title: string;
  state: StepState;
  children?: ReactNode;
}) {
  return (
    <section className="space-y-3">
      <h3 className="flex items-center gap-2 text-small font-semibold">
        <StepMarker state={state} number={number} />
        {title}
      </h3>
      {children ? <div className="space-y-3 pl-7">{children}</div> : null}
    </section>
  );
}
